export default "__VITE_ASSET__C4UR9l28__"